<template>
  <form class="text-center" @submit.stop.prevent>
    <button class="btn btn-success btn-raised text-light" @click.prevent="onEditClick"><i class="fas fa-pen me-2"></i>{{ dictionary.leftBar.carouselConfigText }}</button>
  </form>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'FormConfig',
  model: {
    prop: 'content',
    event: 'change',
  },
  props: {
    content: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapGetters(['dictionary']),
  },
  methods: {
    onEditClick()
    {
      this.$EventBus.$emit('editColumn', {});
    },
  },
};
</script>

<style scoped>

</style>
